const TOKEN_KEY = 'cluster_jwt';
const USER_KEY = 'cluster_user';

export class APIError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = 'APIError';
    this.status = status;
    this.data = data;
  }
}

export function getStoredToken() {
  const token = localStorage.getItem(TOKEN_KEY) || '';
  if (token && tokenContainsLegacyACL(token)) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    return '';
  }
  return token;
}

function tokenContainsLegacyACL(token) {
  try {
    const encoded = token.split('.')[1];
    if (!encoded) return false;
    const base64 = encoded.replaceAll('-', '+').replaceAll('_', '/').padEnd(Math.ceil(encoded.length / 4) * 4, '=');
    const payload = JSON.parse(atob(base64));
    return Object.hasOwn(payload, 'subnets');
  } catch {
    return false;
  }
}

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || 'null');
  } catch {
    return null;
  }
}

export function storeSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export async function request(path, options = {}) {
  const headers = new Headers(options.headers || {});
  const token = getStoredToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);

  let body = options.body;
  if (body !== undefined && body !== null && !(body instanceof FormData) && typeof body !== 'string') {
    headers.set('Content-Type', 'application/json');
    body = JSON.stringify(body);
  }

  const response = await fetch(path, {
    ...options,
    headers,
    body,
  });

  const contentType = response.headers.get('content-type') || '';
  const data = contentType.includes('application/json') || contentType.includes('+json')
    ? await response.json().catch(() => ({}))
    : await response.text();

  if (!response.ok || (data && data.success === false)) {
    if (response.status === 401) window.dispatchEvent(new Event('cluster:unauthorized'));
    const message = data?.error || data?.message || response.statusText || 'Request failed';
    throw new APIError(message, response.status, data);
  }

  return data?.success === true && Object.hasOwn(data, 'data') ? data.data : data;
}

export const api = {
  get: (path, options) => request(path, { ...options, method: 'GET' }),
  post: (path, body, options) => request(path, { ...options, method: 'POST', body }),
  put: (path, body, options) => request(path, { ...options, method: 'PUT', body }),
  delete: (path, options) => request(path, { ...options, method: 'DELETE' }),
};
